"use strict";

angular.module("customer")
.controller("UserManagementFormController", function(
    $scope, $state, $stateParams, UserManagementService, UserService, PatternService, FlashBag, gettextCatalog,
    FormError,
    ModalService, CUSTOMER_TYPE, EMAIL_MAXLENGTH
) {
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    $scope.pattern = PatternService;
    $scope.UserManagementService = UserManagementService;
    $scope.isOwner = false;
    $scope.isCurrentUserCustomer = false;
    $scope.showDeleteButton = false;
    $scope.showTransferOwnershipButton = false;
    $scope.showResendUserInvitationButton = false;
    $scope.hasInstance = !!$stateParams.id;
    $scope.userCustomer = {
        'is_considered_owner': !!(!$scope.hasInstance && $stateParams.is_owner),
    };

    if ($scope.hasInstance) {
        UserManagementService.get($stateParams.id).$promise.then(function onSuccess(data) {
            $scope.userCustomer = data;
            $scope.userCustomer.is_considered_owner_initial = angular.copy($scope.userCustomer.is_considered_owner);
            $scope.userCustomer.can_pay_initial = angular.copy($scope.userCustomer.can_pay);
            $scope.userCustomer.can_manage_payment_methods_initial = angular.copy($scope.userCustomer.can_manage_payment_methods);
            UserService.isUserFetched().then(updateUserData);
        });
    }

    var ACTIONS = {
        DELETE: 'delete',
        UPDATE: 'update',
        CREATE: 'create'
    };
    var action = null;
    $scope.isCustomerTypeBusiness = true;

    UserService.isUserFetched().then(updateUserData);

    function updateUserData(user) {
        if (user && user.customer) {
            $scope.isOwner = user.is_owner;
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
            $scope.isCustomerTypeBusiness = user.customer.type === CUSTOMER_TYPE["BUSINESS"];
            if ($scope.hasInstance) {
                $scope.isCurrentUserCustomer = user.id === $scope.userCustomer.id;
                $scope.showDeleteButton = !$scope.isCurrentUserCustomer;
                $scope.showTransferOwnershipButton = (
                    $scope.isOwner && !$scope.dedicatedVendorId
                    && !$scope.userCustomer.is_considered_owner_initial
                );
                $scope.showResendUserInvitationButton = (
                    $scope.isOwner && !$scope.dedicatedVendorId
                    && !$scope.userCustomer.dedicated_vendor_id
                    && $scope.userCustomer.is_waiting_password_reset
                );
            }
        }
    }

    function deleteUser() {
        UserManagementService.delete($scope.userCustomer).then(
            function onSuccess() {
                FlashBag.success(gettextCatalog.getString("The user was successfully deleted."), true);
                $scope.$broadcast("formSubmissionSucceededUserManagement");
                $state.go("userManagementList");
            },
            function onError(response) {
                $scope.$broadcast("formSubmissionFailedUserManagement", response, true);
                FlashBag.apiError(response);
            }
        )
    }

    function onError(response) {
        $scope.$broadcast("formSubmissionFailedUserManagement", response, true);
        FlashBag.apiError(response);
        var is_email_used = !response.data["email"];
        $scope.UserManagementForm.email.$setValidity("used", is_email_used);
    }

    function updateUser() {
        UserManagementService.update($scope.userCustomer).then(
            function onSuccess(data) {
                $scope.userCustomer = data;
                $scope.userCustomer.is_considered_owner_initial = angular.copy($scope.userCustomer.is_considered_owner);
                $scope.userCustomer.can_pay_initial = angular.copy($scope.userCustomer.can_pay);
                $scope.userCustomer.can_manage_payment_methods_initial = angular.copy($scope.userCustomer.can_manage_payment_methods);
                UserService.refreshCurrentUser().then(updateUserData);
                FlashBag.success(gettextCatalog.getString("The user was updated successfully."));
                $scope.$broadcast("formSubmissionSucceededUserManagement");
                $scope.UserManagementForm.$setPristine();
                action = null;
            },
            onError
        )
    }

    function createUser() {
        UserManagementService.create($scope.userCustomer).then(
            function onSuccess() {
                FlashBag.success(gettextCatalog.getString("The user was created successfully."), true);
                $scope.$broadcast("formSubmissionSucceededUserManagement");
                $state.go("userManagementList");
            },
            onError
        );
    }

    $scope.$on("submitFormUserManagement", function(event, data) {
        $scope.userCustomer.password = data ? data["password"] : '';
        if (action === ACTIONS.UPDATE) {
            updateUser();
        }
        else if (action === ACTIONS.DELETE) {
            deleteUser();
        }
        else if (action === ACTIONS.CREATE) {
            createUser();
        }
    });

    this.getDisabledButtonSubmitUserHelpTipHtmlContent = function() {
        return gettextCatalog.getString("Update/Create a user is only available for the owner.");
    };

    this.submitUpdate = function() {
        action = ACTIONS.UPDATE;
        $scope.$broadcast("confirmPasswordUserManagement");
    };

    this.submitDelete = function() {
        action = ACTIONS.DELETE;
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "selector",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Delete User"),
                    message: gettextCatalog.getString("Do you really want to delete this user?")
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                if (result) {
                    $scope.$broadcast("confirmPasswordUserManagement");
                }
            });
        });
    };

    this.submitCreate = function() {
        action = ACTIONS.CREATE;
        $scope.$broadcast("confirmPasswordUserManagement");
    };

    this.validate = function() {
        $scope.UserManagementForm.email.$setValidity("used", true);
        if (!$scope.isOwner || !!$scope.dedicatedVendorId) {
            return;
        }

        $scope.UserManagementForm.$setSubmitted();
        FlashBag.clearAll();

        if (!$scope.UserManagementForm.$valid) {
            FormError.focus("UserManagementForm");
        }
        else if ($scope.hasInstance) {
            this.submitUpdate();
        }
        else {
            this.submitCreate();
        }
    };

    this.transferOwnership = function(userCustomerId) {
        UserManagementService.transferOwnership(userCustomerId);
    };

    this.sendUserInvitation = function(userCustomerId) {
        UserManagementService.sendUserInvitation(userCustomerId);
    };

    this.updatePermissions = function() {
        $scope.userCustomer.can_pay = $scope.userCustomer.is_considered_owner || $scope.userCustomer.can_pay_initial;
        $scope.userCustomer.can_manage_payment_methods = $scope.userCustomer.is_considered_owner || $scope.userCustomer.can_manage_payment_methods_initial;
    };

    this.updatePermissions();
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/user-management/user-management-form.controller.js
// module id = 964
// module chunks = 0